@if (istText()) {
	<!-- Beschriftung im Feld wie bei allen anderen Feldern der Masken. Bis
	     02.10.2026 stand hier eine graue Beschriftungsspalte, deren Stil dieses
	     Bauteil gar nicht erreicht (er steht in hl-area.component.css) - sie fiel
	     nur zufaellig ueber das Feld. -->
	<div class="form-row">
		<div class="form-input-cell full-width">
			<wd-multiline-text-input name="Bestand" label="Bestand-Text" [(model)]="data.extendedHeader.baumarten"></wd-multiline-text-input>
		</div>
	</div>

	@if (vorschlag().kind !== 'leer') {
		<div class="bestand-preview">
			@if (zeigeBestaetigt()) {
				<div class="sea-line">
					<span class="text-success"><i class="bi bi-check2"></i> Abweichende Beschreibung bestätigt</span>
					<button type="button" class="btn btn-sm btn-outline-secondary" (click)="bestaetigungAufheben()">
						<i class="bi bi-x-circle"></i> Bestätigung aufheben
					</button>
				</div>
			} @else if (geaendert()) {
				<div class="sea-line">
					<span class="rw-label">SEA</span>
					<code class="canon">{{ vorschlag().kanonisch }}</code>
					<button type="button" class="btn btn-sm btn-primary" (click)="uebernehmen()">
						<i class="bi bi-arrow-repeat"></i> In SEA-Form bringen
					</button>
					<button type="button" class="btn btn-sm btn-outline-success" (click)="bestaetigen()">
						<i class="bi bi-check2"></i> Beschreibung so bestätigen
					</button>
				</div>
			} @else if (kannRueckgaengig()) {
				<div class="sea-line">
					<span class="text-success"><i class="bi bi-check2"></i> in SEA-Form übernommen</span>
					<button type="button" class="btn btn-sm btn-outline-secondary" (click)="rueckgaengig()">
						<i class="bi bi-arrow-counterclockwise"></i> Rückgängig
					</button>
					<span class="orig-hint">Original: <code>{{ gespeichertesOriginal() }}</code></span>
				</div>
			} @else if (istOffenland()) {
				<span class="text-muted">Offenland – kein Baumbestand.</span>
			} @else if (!istSeaKonform()) {
				<div class="sea-line">
					<span class="text-warning"><i class="bi bi-exclamation-triangle"></i> Beschreibung ist nicht SEA-konform.</span>
					<button type="button" class="btn btn-sm btn-outline-success" (click)="bestaetigen()">
						<i class="bi bi-check2"></i> Beschreibung so bestätigen
					</button>
				</div>
			} @else {
				<span class="text-success"><i class="bi bi-check2"></i> SEA-Form</span>
			}

			@if (zeigeHinweise()) {
				<div class="hinweise">
					<div class="hinweise-titel"><i class="bi bi-exclamation-triangle"></i> Bitte noch klären:</div>
					<ul>
						<li *ngFor="let h of hinweise()">{{ h }}</li>
					</ul>
				</div>
			}
		</div>
	}
} @else {
	<div class="alert alert-info">
		Für diesen Punkt ist die Probestämme-Tabelle aktiv — die Bestand-Konvertierung
		ist hier noch nicht verfügbar (folgt mit dem strukturierten Editor).
	</div>
}

<!-- Freitext-Zusatz: Originaltext (Import/Altdaten) bzw. zusätzliche Infos -->
<div class="form-row">
	<div class="form-input-cell full-width">
		<wd-multiline-text-input name="BestandFreitext" label="Zusatz / Original" title="Originaltext bei Import/Altdaten bzw. zusätzliche Infos, die nicht in die SEA-Form passen" [(model)]="data.extendedHeader.bestandFreitext"></wd-multiline-text-input>
	</div>
</div>
